import { s as t, _ as o } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as e from "react";
import { s as i, c as a } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var r = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  o({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, l),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M31.92 13.007 4.182 29.511a8.835 8.835 0 0 1-1.32-1.337L28.64 3.25c1.987 2.08 2.527 4.66 2.527 4.66.41 1.702.642 3.43.753 5.098Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E87E04",
      fillRule: "evenodd",
      d: "M31.046 7.454 3.692 29.081a9.063 9.063 0 0 1-.85-.931L28.636 3.247c1.481 1.548 2.16 3.375 2.409 4.207Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m6.5 13-.227-3.777-.792 2.08.353-2.196L4.53 10.91l.91-2.03-1.726 1.405L5.12 8.559l-2.03.91 1.803-1.303-2.198.353 2.08-.792L1 7.5l3.775-.227-2.08-.792 2.198.353L3.09 5.53l2.031.911-1.405-1.726L5.441 6.12 4.53 4.09l1.304 1.803-.353-2.197.792 2.08L6.5 2l.227 3.775.792-2.079-.353 2.197L8.469 4.09l-.912 2.03 1.728-1.405L7.88 6.441l2.03-.911-1.803 1.304 2.197-.353-2.08.792L12 7.5l-3.777.227 2.08.792-2.196-.353L9.91 9.469l-2.031-.91 1.405 1.726L7.557 8.88l.912 2.03-1.303-1.803.353 2.197-.792-2.08L6.5 13Z",
      clipRule: "evenodd"
    }
  )
), p = i(r)`
  ${t}
  ${a}
`, g = p;
export {
  g as default
};
